function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// GENERATED BY ./scripts/generate.ts
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import MistralFilledSvg from '@ant-design/icons-svg/lib/asn/MistralFilled';
import AntdIcon from "../components/AntdIconLight";
const MistralFilled = (props, ref) => /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
  ref: ref,
  icon: MistralFilledSvg
}));

/**![mistral](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTcwNCAxOTIuMDJ2MTI3Ljk3SDU3NnYxMjguMDJINDQ4VjMyMEgzMjBWMTkyLjA1SDE5Mi4wNXY1MTJINjR2MTI3Ljk3aDM4NC4wMVY3MDQuMDRIMzIwVjU3Ni4wM2gxMjguMDJ2MTI4LjAxaDEyOC4wMlY1NzYuMDNINzA0djEyOC4wMUg1NzYuMDN2MTI3Ljk4SDk2MFY3MDQuMDRIODMxLjk1VjE5Mi4wMnoiIC8+PC9zdmc+) */
const RefIcon = /*#__PURE__*/React.forwardRef(MistralFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'MistralFilled';
}
export default RefIcon;